import React, { PropsWithChildren, ReactElement } from 'react';

import { IPageFetcher } from '../page';

import { PageFetcherContext } from './PageFetcherContext';

export interface IPageFetcherProviderProps extends PropsWithChildren<any> {
    fetcher: IPageFetcher;
}

export function PageFetcherProvider (props: IPageFetcherProviderProps): ReactElement {
    const { fetcher, children }: IPageFetcherProviderProps = props;

    return (
        <PageFetcherContext.Provider value={fetcher}>
            {children}
        </PageFetcherContext.Provider>
    );
}
